<template>
  <v-toolbar class="mt-7">
    <v-row>
      <v-col class="welcomeToolBarTitle" data-cy="welcomeMessage" data-test="welcomeMessage"
        >Welcome {{ firstName }}!</v-col
      >
      <v-col md="4">
        <pack-selector
          :loading="packDataIsLoading"
          :packList="packList"
          topMargin="4"
          @selectPack="navigateToDashboard"
        ></pack-selector>
      </v-col>
    </v-row>
  </v-toolbar>
</template>

<script>
import PackSelector from "@/components/PackSelector";
import { getDashboardRedirect } from "@/router/dashboardRedirect";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  components: { PackSelector },
  computed: {
    ...mapGetters({
      hasDashboardQaView: "session/hasDashboardQaView",
      hasDashboardAccountManagerView: "session/hasDashboardAccountManagerView",
      hasDashboardUatView: "session/hasDashboardUatView",
    }),
    ...mapState({
      firstName: state => state.session.user["first-name"],
      packList: state => state.pack.packList,
      serviceArea: state => state.session.user.serviceArea,
    }),
  },
  async created() {
    if (this.packList.length > 1) {
      return;
    }
    try {
      this.packDataIsLoading = true;
      await this.getPackList();
    } catch (error) {
      console.error(error);
      this.$notifyError({ message: "Unable to fetch pack list" });
    }
    this.packDataIsLoading = false;
  },
  data() {
    return {
      packDataIsLoading: false,
    };
  },
  methods: {
    navigateToDashboard(id) {
      const permissions = {
        hasDashboardQaView: this.hasDashboardQaView,
        hasDashboardAccountManagerView: this.hasDashboardAccountManagerView,
        hasDashboardUatView: this.hasDashboardUatView,
        serviceArea: this.serviceArea,
      };

      const redirect = getDashboardRedirect(permissions, { name: null, packId: id });

      this.$router.push(redirect || { name: "dashboard", params: { packId: id } });
    },
    ...mapActions({
      getPackList: "pack/getList",
    }),
  },
};
</script>

<style scoped>
.welcomeToolBarTitle {
  font-size: 1.25rem;
}
</style>
